/*
 * @Author: chenzheng
 * @Date: 2019-01-17 22:03:38
 * @LastEditors: chenzheng
 * @LastEditTime: 2019-01-17 22:42:50
 * @Description: 快速开单
 */
// 账户
const bill = () => import(/* webpackChunkName: 'bill' */ '@views/bill')
const billIndvidual = () =>
  import(/* webpackChunkName: 'billMember' */ '@views/bill/indvidual/indvidual')
const billMember = () => import(/* webpackChunkName: 'billMember' */ '@views/bill/member/member')

const routes = [
  {
    path: '/bill',
    component: bill,
    name: 'bill',
    meta: { title: '', first: false, resourceCode: '', keepAlive: true },
    children: [
      {
        path: 'indvidual',
        component: billIndvidual,
        name: 'billIndvidual',
        meta: {
          keepAlive: true
        }
      },
      {
        path: 'member',
        component: billMember,
        name: 'billMember',
        meta: {
          keepAlive: true
        }
      }
    ]
  }
]
export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/bill/index.js